import { useEffect } from 'react';

import { useAgGridClientTableContext } from 'core/states';

// AG Grid caches the result of getRowClass per node and doesn't re-evaluate it on sort or
// filter changes (it just reorders / hides rows). The zebra stripe in this grid is computed
// from each group's position in childrenAfterSort, so we need to force a row redraw whenever
// the displayed order or filter set changes — otherwise stripes get out of sync.
//
// Side-effect-only component. Mount it inside AgGridClientTableProvider; renders null.
export const GroupStripeRefresher = () => {
  const { gridApi } = useAgGridClientTableContext();

  useEffect(() => {
    if (!gridApi || gridApi.isDestroyed()) {
      return;
    }

    const redraw = () => {
      if (!gridApi.isDestroyed()) {
        gridApi.redrawRows();
      }
    };

    gridApi.addEventListener('sortChanged', redraw);
    gridApi.addEventListener('filterChanged', redraw);

    return () => {
      if (!gridApi.isDestroyed()) {
        gridApi.removeEventListener('sortChanged', redraw);
        gridApi.removeEventListener('filterChanged', redraw);
      }
    };
  }, [gridApi]);

  return null;
};
